<div class="add-domain" [formGroup]="addDomainsFormGroup">
  <app-popup-top-line></app-popup-top-line>
  <div class="add-domain-header">
    <div class="title">
      {{ 'policyPage.config.trustedDomainsContent.addDomain' | labelsProvider }}
    </div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="add-domain-body" formArrayName="domainsToAdd">
    <div class="section-title" *ngIf="domainsToAdd.length > 0">New Domains to Add</div>
    <div
      class="domain-input-container"
      *ngFor="let control of domainsToAdd.controls; let i = index"
      [formGroupName]="i"
    >
      <div
        class="input"
        [class.input-invalid]="
          (control.get('domain')?.errors?.['duplicate'] ||
            control.get('domain')?.errors?.['coveredByWildcard'] ||
            control.get('domain')?.errors?.['wildcardConflictInForm'] ||
            control.get('domain')?.errors?.['domain']) &&
          control.get('domain')?.touched
        "
      >
        <input
          type="text"
          formControlName="domain"
          placeholder="{{ 'policyPage.config.trustedDomainsContent.enterDomain' | labelsProvider }}"
        />
        <img *ngIf="i > 0" src="assets/images/common/cancel.svg" (click)="removeDomain(i)" />
      </div>
      <div class="error-message" *ngIf="control.get('domain')?.errors?.['duplicate'] && control.get('domain')?.touched">
        This domain already exists in the policy
      </div>
      <div
        class="error-message"
        *ngIf="control.get('domain')?.errors?.['coveredByWildcard'] && control.get('domain')?.touched"
      >
        This domain is already covered by "{{ control.get('domain')?.errors?.['coveredByWildcard'].existingDomain }}"
      </div>
      <div
        class="error-message"
        *ngIf="control.get('domain')?.errors?.['wildcardConflictInForm'] && control.get('domain')?.touched"
      >
        Remove "{{ control.get('domain')?.errors?.['wildcardConflictInForm'].existingDomain }}" first - it will be
        covered by this wildcard
      </div>
      <div class="error-message" *ngIf="control.get('domain')?.errors?.['domain'] && control.get('domain')?.touched">
        Invalid domain format. Use a valid domain (e.g., example.com) or wildcard (e.g., *.example.com)
      </div>
      <div
        class="warning-message"
        *ngIf="
          control.get('domain')?.valid &&
          control.get('domain')?.value?.startsWith('*.') &&
          isBaseDomainMissing(control.get('domain')?.value)
        "
      >
        <span class="warning-icon">⚠</span>
        Wildcard does not include "{{ control.get('domain')?.value?.substring(2) }}", add it as a separate domain if
        needed
      </div>
    </div>

    <div class="add-domain-actions">
      <div class="add-more" (click)="addMoreClicked()">
        <img class="add-more-img" src="assets/images/common/plus.svg" />
        <div class="add-domain-button-title">
          {{ 'policyPage.config.trustedDomainsContent.addMore' | labelsProvider }}
        </div>
      </div>

      <div class="bulk-upload" (click)="triggerFileUpload()" [class.disabled]="processingFile()">
        <img class="bulk-upload-img" src="assets/images/common/import.svg" />
        <div class="add-domain-button-title">
          {{ processingFile() ? 'Processing...' : 'Bulk Upload' }}
        </div>
      </div>
    </div>

    <div class="bulk-upload-help">
      Upload a CSV file with domains (one per line or in the first column, up to 2000 domains per file)
    </div>

    <!-- Skipped domains section -->
    <div class="skipped-domains-section" *ngIf="skippedDomains().length > 0">
      <div class="skipped-domains-header" (click)="toggleSkippedDomains()">
        <img
          class="expand-icon"
          [src]="
            showSkippedDomains() ? 'assets/images/common/collapse-nodes.svg' : 'assets/images/common/expand-nodes.svg'
          "
        />
        <span class="skipped-title">
          {{ skippedDomains().length }} domain{{ skippedDomains().length > 1 ? 's' : '' }} already exist (click to
          {{ showSkippedDomains() ? 'hide' : 'show' }})
        </span>
      </div>
      <div class="skipped-domains-list" *ngIf="showSkippedDomains()">
        <div class="skipped-domain" *ngFor="let domain of skippedDomains()">
          {{ domain }}
        </div>
      </div>
    </div>

    <!-- Invalid domains section -->
    <div class="invalid-domains-section" *ngIf="invalidDomains().length > 0">
      <div class="invalid-domains-header" (click)="toggleInvalidDomains()">
        <img
          class="expand-icon"
          [src]="
            showInvalidDomains() ? 'assets/images/common/collapse-nodes.svg' : 'assets/images/common/expand-nodes.svg'
          "
        />
        <span class="invalid-title">
          {{ invalidDomains().length }} invalid domain{{ invalidDomains().length > 1 ? 's' : '' }} (click to
          {{ showInvalidDomains() ? 'hide' : 'show' }})
        </span>
      </div>
      <div class="invalid-domains-list" *ngIf="showInvalidDomains()">
        <div class="invalid-domain" *ngFor="let domain of invalidDomains()">
          {{ domain }}
        </div>
      </div>
    </div>

    <!-- Domains to be replaced section -->
    <div class="replace-domains-section" *ngIf="domainsToReplace().length > 0">
      <div class="replace-domains-header" (click)="toggleDomainsToReplace()">
        <img
          class="expand-icon"
          [src]="
            showDomainsToReplace() ? 'assets/images/common/collapse-nodes.svg' : 'assets/images/common/expand-nodes.svg'
          "
        />
        <span class="replace-title">
          {{ domainsToReplace().length }} domain{{ domainsToReplace().length > 1 ? 's' : '' }} will be replaced (click
          to {{ showDomainsToReplace() ? 'hide' : 'show' }})
        </span>
      </div>
      <div class="replace-domains-list" *ngIf="showDomainsToReplace()">
        <div class="replace-domain" *ngFor="let domain of domainsToReplace()">
          {{ domain }}
        </div>
      </div>
    </div>

    <!-- Hidden file input for CSV upload -->
    <input #csvFileInput type="file" accept=".csv" style="display: none" (change)="onFileSelected($event)" />
  </div>
  <div class="add-domain-footer">
    <button class="cancel" (click)="onClose()">
      {{ 'common.cancel' | labelsProvider }}
    </button>
    <button
      class="confirm"
      [ngClass]="{
        'confirm-disabled': waitingForResponse,
      }"
      [disabled]="waitingForResponse"
      (click)="addDomains()"
      cdkFocusInitial
    >
      <span *ngIf="!waitingForResponse">{{ 'common.add' | labelsProvider }}</span>
      <mat-progress-spinner class="spinner" *ngIf="waitingForResponse" color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </button>
  </div>
</div>
